<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
      <div class="mb3 text-left">
         <span class="no_permohonan">{{data.no_permohonan}}</span> | <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
      </div>
    <z-page title="Maklumat Permohonan" >
      <div class="table_scrol">
        <table class="w-table" color="light" style="width: 100%; margin: 0;">
          <tbody><tr><td>
           <w-card bg-color="" class="">
             <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
               <div class="w-flex wrap smd-column">
                 <div class="grow xs12" style="line-height: 15px">
                   <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                     <tr class="row_data">
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>ID Premis</b>&nbsp;: {{data.no_nama_premis}}
                       </td>
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Jenis Ternakan</b>&nbsp;: {{data.lkp_ternakan}}
                       </td>
                       <td style="text-align: left; width: 40%; white-space: nowrap;">
                         <b>Jenis Baka</b>&nbsp;: {{data.lkp_jenis_baka}}
                       </td>
                     </tr>
                     </tbody>
                   </table>
                 </div>
               </div>
             </w-form>
           </w-card>
           </td></tr></tbody>
         </table>
        <br>
        <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI TERNAKAN'">
        <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
          <template #title>
            SENARAI TERNAKAN
          </template>
          <div class="w-table-wrap" style="max-height: 400px;">
            <div class="table-profil-scrol">
              <table class="w-table" color="light">
                <thead>
                  <tr>
                    <th class="w-table__header text-center" width="1%">BIL</th>
                    <th class="w-table__header text-center">NO PENDAFTARAN</th>
                    <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                    <th class="w-table__header text-center">ID INDUK</th>
                    <th class="w-table__header text-center">BAKA</th>
                    <th class="w-table__header text-center">JANTINA</th>
                    <th class="w-table__header text-center">TARIKH LAHIR</th>
                    <th class="w-table__header text-center">(UMUR BULAN)</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(dt, ind) in data.ternakan_list" :key="dt.id">
                    <tr class="w-table__row">
                      <td class="w-table__cell text-center">{{ind+1}}</td>
                      <td class="w-table__cell text-center">{{dt.no_pendaftaran}}</td>
                      <td class="w-table__cell text-center">{{dt.ternakan_nama}}</td>
                      <td class="w-table__cell text-center">{{dt.id_bapa}}</td>
                      <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                      <td class="w-table__cell text-center">{{dt.jantina}}</td>
                      <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
                      <td class="w-table__cell text-center">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>
                      
                      
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </w-form>
      </w-card>
      <br>
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'STATUS KESIHATAN'">
        <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
          <template #title>
            STATUS KESIHATAN
          </template>
         <span class="input-hint">Dokumen Sokongan</span>
          <div class="w-table-wrap" style="max-height: 400px;">
           <div class="table-profil-scrol">
             <table class="w-table" color="light">
               <thead>
                 <tr>
                   <th class="w-table__header text-center" width="1%">BIL</th>
                   <th class="w-table__header text-center">KETERANGAN</th>
                   <th class="w-table__header text-center">NAMA FAIL</th>
                   <th class="w-table__header text-center">NO KES</th>
                 </tr>
               </thead>
               <tbody>
                 <template v-for="(dt, ind) in data.baka_dokumen_list" :key="dt.id">
                   <tr class="w-table__row">
                     <td class="w-table__cell text-center">{{ind+1}}</td>
                     <td class="w-table__cell text-center">{{dt.nama}}</td>
                     <td class="w-table__cell text-center">
                       <a v-if="dt.atthectment_dokumen && dt.atthectment_dokumen.length > 0" 
                          :href="dt.atthectment_dokumen[0].url" 
                          target="_blank" 
                          class="text-blue-500 hover:underline">
                         {{dt.dokumen_nama}}
                       </a>
                       <span v-else>{{dt.dokumen_nama || '-'}}</span>
                     </td>
                     <td class="w-table__cell text-center">
                         <w-tooltip md top color="white" bg-color="black">
                            <template #activator="{ on }">
                                    <a v-on="on" 
                                       @click="url_kes(dt.no_kes)" 
                                       style="text-decoration: underline; color: #3a3ad0;">
                                       {{ dt.no_kes }}
                                    </a>
                            </template>
                                 <span>
                                    https://myvetlab.dvs.gov.my/myvetlabservis/senarai-keputusan-smartfarming.php?no_kes={{ dt.no_kes }}
                                 </span>
                        </w-tooltip>
                      </td>
                   </tr>
                 </template>
               </tbody>
             </table>
           </div>
         </div>
          
        </w-form>
      </w-card>
             <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
    VueQrcode,
  },
  props: {
    id: [Array, Object, String],

  },
  data() {
    return {
      // resourceurl: 'baka.permohonan',
      resourceurl: this.api_service + "baka",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Baka Permohonan', route: '/baka' },
        { label: 'Permohonan', route: '/baka/permohonan' },
        { label: 'Papar', route: '/baka/permohonan/'+this.id },
      ],

      title : '',
      form : {
        id : 0,
        catatan :'',
        penyakit : '',
        lkp_baka_saranan_id : '',
        catatan_semakan: '',
        hantar : 0,
        penyakit: {},
        submitted: false,
      sent: false,
      valid: false
        
      },
      activeTab : 0,
      ternakan_list:[],
      lkp_status : [],
      baka_dokumen_list:[],
      baka_saranan_list:[],
      penyakit_list:[
        {value: 1, label: "Positif"},
        {value: 2, label: "Negatif"},
        {value: 3, label: "Tiada Tanda Klinikal"},
      ],
    }
  },
  validators: {
  
  validatePenyakitList: (value, context) => {
    
    if (context.form.hantar !== 1 && context.form.hantar !== 3) {
      return true; 
    }
    
    
    const penyakitList = context.data.baka_penyakit_list || [];
    const hasUnselected = penyakitList.some(item => !item.status);
    
    if (hasUnselected) {
      return "Sila pilih status untuk semua penyakit";
    }
    
    return true;
  }
},
  methods: {

    tutup(){
         this.$inertia.visit(window.route('baka.index'));
       },

     nl2br(text) {
       if (!text) return '';
       return text.replace(/\\n/g, '<br>');
     },


   

         getStatus(){
         this.$zcomm.get(this.api_service + 'lookup/status_mohon', {}).then(res => {
           this.lkp_status = res
         })
       },


      getData() {
      this.$zcomm.get(this.api_service + 'baka/show/'+this.id, {}).then(res => {
        this.data = res
        this.form.catatan = this.data.catatan ?? null;
        this.form.catatan_semakan = this.data.catatan_semakan ?? null;
        if(this.data.lkp_status_id == 18 ||this.data.lkp_status_id == 21){
           this.form.lkp_status_id = this.data.lkp_status_id ?? null;
        }
        if (this.data.ternakan_list) {
          this.data.ternakan_list.forEach(item => {
            if (item.pilih === undefined) {
              this.$set(item, 'pilih', false)
            }
          })
          if (this.data.lkp_baka_saranan_id) {
            this.data.baka_saranan_list.forEach(item => {
               if(item.lkp_baka_saranan_id == item.id){
               this.klickPi(item, item.lkp_baka_saranan_id);
               return;
               }
            });
          }
        }
        
      })
    },

    url_kes(kes) {
      this.$zcomm.get(this.api_service + 'integrasi/kes/'+kes, {}).then(res => {
          res.urls.forEach(url => {
             window.open(url, "_blank")
          })
    
      })
       .catch(err => {
            this.$zutil.notify("no_kes: Tiada dalam sistem MyVetLab", false);
            console.error(err);
        });
   },
    



  },
  watch: {

  },
  mounted() {
    this.getData();
    this.getStatus();


  },
}
</script>

<style>

.abnormal-input {
  margin-top: 1rem;
}


.input-hint {
  color: black;
  font-size: 1.1em;
  display: block;
  margin-top: 8px;
  margin-bottom: 8px;
}

.no_permohonan {
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
}
table{
  width: 100%;
}
</style>
